import {campaignSort,writeCampaignSort} from '../features/campaign-workspace/campaignViewState.js'
import RepViewNavigation from '../features/campaign-workspace/RepViewNavigation.jsx'
import RecordCampaignWorkspace from '../features/campaign-workspace/RecordCampaignWorkspace.jsx'
import {campaignParams,closeCampaignParams,preferredRepView} from '../features/campaign-workspace/campaignNavigation.js'
import { inSupportedBook, supportedBookReadStatus, championshipReadSummary } from '../features/command-center/championshipReadView.js'
import {matchesCoverageMember,coverageIdForRepName} from '../lib/schoolTeamOverlay.js'
import {useToolAccess,ToolGate} from '../lib/toolAccess.jsx'
import {toolAvailable} from '../lib/toolAccessPolicy.js'
import { splitParentSummary } from '../features/command-center/pursuit/splitParentSummary.js'
import { titleTierFor } from '../lib/titleTierView.js'
import { useState, useMemo, useRef, useCallback, useEffect } from 'react'
import { useSearchParams, useLocation } from 'react-router-dom'
import { readBoardFilters, writeBoardFilters } from '../features/command-center/boardNavigation.js'
import PageHeader from '../components/PageHeader.jsx'
import Disclosure from '../components/Disclosure.jsx'
import { RecentLandings, EngineAgents } from '../components/AgentBadge.jsx'
import { LastHuntLine, LastHuntDetail, useLastHunt, useLastHuntReach } from '../components/LastHunt.jsx'
import OpportunityQueue from '../features/command-center/OpportunityQueue.jsx'
import ErrorBoundary from '../components/ErrorBoundary.jsx'
import { useCategoryUniverse } from '../features/command-center/useCategoryUniverse.js'
import CategoryRail, { SpaceEmpty } from '../features/command-center/CategoryRail.jsx'
import {
  categoryFor, viewsFor, defaultViewFor, allowsWrites, DEFAULT_CATEGORY_KEY,
  recordsLabelFor, exportTitleFor, dateLabelFor, isDatedSpace, linkLabelFor,
  mapNounFor, isCommunityHero, isGreekPursuit, isCheerPartnership,
  heroLabelFor, honoreeNounFor, viewUse,
  COMMUNITY_HERO, GREEK_PURSUIT, CHEER_PARTNERSHIP,
} from '../features/command-center/categories.js'
import { attachCheerRollup } from '../features/command-center/cheer.js'
import CheerGyms from '../features/command-center/pursuit/CheerGyms.jsx'
import CheerWorkOrder from '../features/command-center/pursuit/CheerWorkOrder.jsx'
import RecognitionModal from '../features/command-center/RecognitionModal.jsx'
import { nextStepFor } from '../features/command-center/nextStep.js'
import { PathwayBar } from '../features/command-center/pursuit/NextStep.jsx'
import CrownMap from '../features/command-center/CrownMap.jsx'
import FilterBar from '../features/command-center/pursuit/FilterBar.jsx'
import PursuitBoard from '../features/command-center/pursuit/PursuitBoard.jsx'
import { useBoardControls } from '../features/command-center/pursuit/useBoardControls.js'
import DateFilter from '../components/DateFilter.jsx'
import { applyDateFilter } from '../lib/dateFilter.js'
import Worklist from '../features/campaign-workspace/CampaignWorklist.jsx'
import CountdownCalendar from '../features/command-center/pursuit/CountdownCalendar.jsx'
import GapsBoard from '../features/command-center/pursuit/GapsBoard.jsx'
import SweepPanel from '../features/command-center/pursuit/SweepPanel.jsx'
import HuntedBoard from '../features/command-center/pursuit/HuntedBoard.jsx'
import AddChampionship from '../features/command-center/pursuit/AddChampionship.jsx'
import Assignments from '../features/command-center/pursuit/Assignments.jsx'
import Readiness from '../features/command-center/pursuit/Readiness.jsx'
import { BulkAssignBar } from '../features/command-center/pursuit/AssignRep.jsx'
import { assignmentAudit, currentRep } from '../features/command-center/assignments.js'
import { pickerMode, laneDestinationOk, partitionForLane } from '../features/command-center/laneDelegation.js'
import { explainAssignFailure, explainBulkFailures } from '../lib/assignErrors.js'
import { useAccess } from '../lib/access.jsx'
import PursuitStages from '../features/command-center/pursuit/PursuitStages.jsx'
import JustWon from '../features/command-center/pursuit/JustWon.jsx'
import ManagerRollup from '../features/command-center/pursuit/ManagerRollup.jsx'
import ChampionToClose from '../features/champion-to-close/ChampionToClose.jsx'
import ChampionshipDrawer from '../features/command-center/ChampionshipDrawer.jsx'
import ArtworkCreated from '../features/artwork-created/ArtworkCreated.jsx'
import SavedArtworkComposer from '../features/workspace/SavedArtworkComposer.jsx'
import ExportCsv from '../features/command-center/ExportCsv.jsx'
import useRowSelection from '../features/command-center/useRowSelection.js'
import useWorklistScope from '../features/campaign-workspace/useCampaignWorklistScope.js'
import CrownModal from '../features/command-center/CrownModal.jsx'
import WeekBoard from '../features/command-center/WeekBoard.jsx'
import BowlDeskPanel from '../features/bowl/BowlDeskPanel.jsx'
import { aggregateByState, gapBuckets, PURSUIT_META, ownerName, dateStamp,
  UNASSIGNED_FILTER,
} from '../lib/championships.js'
import { searchRecords } from '../features/command-center/recordSearch.js'
import { multiChampion } from '../features/command-center/pursuit/multiChampion.js'
import { api } from '../lib/api.js'
import DateStamp from '../features/command-center/pursuit/DateStamp.jsx'
import ScopeNote from '../features/command-center/ScopeNote.jsx'
import StatePanel from '../features/command-center/StatePanel.jsx'
import styles from './CommandCenter.module.css'

// `product` is the pursuit spaces' "what is this FOR" dimension (an RFP's
// `sr_rfp_category`) and `industry` is the Corporate space's "what do they DO"
// qualifier. Both live in the shared filter shape and are simply inert —
// disabled control, no-op predicate — in a space whose records don't carry one.
const EMPTY_FILTERS = { book: '', bowlMember: '', titleTier: '', sport: '', industry: '', level: '', state: '', product: '', incumbent: '', owner: '', year: '', q: '' }

// The pursuit / win-loss-in-contention legend shown above the views.
const LEGEND = ['Champion Crowned', 'Won', 'Outreach In Progress', 'To Pursue', 'Not Started']

/**
 * HOW OLD IS THIS COUNT? Rendered beside the number, never instead of it.
 *
 * ⚠️ RELATIVE, AND IT IS A DELIBERATE CHOICE. An ISO timestamp is precise and
 * nobody subtracts it in their head — "15,103 records · 2026-10-02T03:00:09Z"
 * still gets quoted as current at 6am. "read 3h ago" cannot be misread as now.
 * The exact instant is on the `title` for anyone who needs it.
 *
 * Returns `null` for nothing, so the caller renders "read time not reported"
 * rather than a confident, invented freshness.
 */
function formatReadAge(stamp) {
  const t = stamp?.asOf ? Date.parse(stamp.asOf) : NaN
  if (!Number.isFinite(t)) return 'time not reported'
  const secs = Math.max(0, Math.round((Date.now() - t) / 1000))
  if (secs < 45) return 'just now'
  if (secs < 5400) return `${Math.round(secs / 60)}m ago`
  if (secs < 172800) return `${Math.round(secs / 3600)}h ago`
  return `${Math.round(secs / 86400)}d ago`
}

/**
 * THE COMMAND CENTER — now a set of CATEGORY SPACES rather than a single
 * championship board with a Pursuits tab bolted on.
 *
 * The rail at the top selects the space; everything below it — the universe,
 * the filter bar's options, every view, the row selection, the CSV export and
 * the map — is scoped to that space and nothing else. The registry
 * (`features/command-center/categories.js`) is the only place that knows the
 * categories exist; this page renders whatever it declares.
 *
 * THE RAIL IS PURELY ADDITIVE. The Championships space is the default and is
 * required to open and behave EXACTLY as the Command Center did before the rail
 * existed — every view, every write action, and the same copy word for word.
 * That is why the championship strings live in the registry and why the
 * pursuit-space affordances below (the honest empty card, the official-listing
 * link) are all conditioned on `source === 'pursuits'` rather than on emptiness
 * alone: nothing new may reach the championship surface.
 */
function CommandCenterContent({effectiveView}) {
  const toolAccess=useToolAccess()
  const location = useLocation()
  const now = useRef(new Date()).current
  const [params, setParams] = useSearchParams()
  // THE ASSIGNMENT GATE — "Manage Assignments". One resolved decision, shared
  // by the worklist, every row picker and the bulk bar, so a denied user gets
  // the same read-only surface and the same reason everywhere.
  const { ctx: accessContext, manageAssignments, laneDelegation, role: accessRole, bookMeta, scopeError, book: accessBook } = useAccess()

  const categoryKey = params.get('space') || DEFAULT_CATEGORY_KEY
  const category = categoryFor(categoryKey)
  const views = useMemo(() => viewsFor(category).filter(v=>['partnership','workorder'].includes(v.key)||toolAccess?.available(`cc.${v.key}`)), [category,toolAccess])
  const writes = allowsWrites(category)
  // What this space's effective date is CALLED — "Event date" for a
  // championship, "Close date" for an RFP. Every dated view reads it, so no
  // column header hardcodes the championship wording.
  const dateLabel = dateLabelFor(category)
  // …and whether it HAS one at all. An employee-recognition space (Corporate)
  // has no event to count down to, so the date column, the countdown and the
  // NO DATE gap bucket are switched off rather than shown blank on every row.
  const dated = isDatedSpace(category)
  // The heading on a record's official link — "Website" for a company, the
  // official solicitation listing for an RFP.
  const linkLabel = linkLabelFor(category)
  // WHAT A RECORD IS CALLED on the shared surfaces that print a noun of their
  // own — the map (title, hint, markers, tooltips, counts) and the manager
  // rollup's totals. Only Championships resolves to "championship"; every other
  // space gets its own word, and an undeclared one gets "opportunities" rather
  // than being mislabelled a championship. See `mapNounFor` in categories.js.
  const spaceNoun = mapNounFor(category)

  const {
    /* ⚠️ `asOf` WAS BEING COMPUTED AND THROWN AWAY. useChampionships has carried
     * `{ asOf, ageSeconds, cached }` all along and this page never destructured
     * it, so every count on the Command Center rendered with no indication of
     * when it was read. That is the same defect as the stale comment, one layer
     * out: a number with no timestamp is a claim about a reader and a moment, and
     * 6,177 / 5,728 were quoted as current for hours because nothing on screen
     * could age them. Measured live 2026-10-02T03:00:09Z: 15,103 total, 11,312
     * assigned, 3,791 unassigned. */
    data: universe, status, error, reload, loadedCount, pageCount, complete, demo, patchLocal, pending, asOf,
    championships, championshipsComplete, championshipsStatus, championshipsReadHealthy, degraded, building,
    /* NOT PART OF THE REVIEWS WORK — a pre-existing build break found by the
     * deploy on 2026-09-11 and fixed here because it blocks every release.
     *
     * The load receipt below reads `loadMode` on lines 753/756/761 to say
     * whether the universe arrived as one snapshot or a walked cursor, but the
     * identifier was never destructured: three `no-undef` errors, exit code 2,
     * no deploy. `useChampionships()` has returned `loadMode` all along and the
     * championships branch of `useCategoryUniverse` spreads `...champ`, so the
     * value was there the whole time — only the binding was missing. A pursuit
     * space returns no `loadMode`, which the `{!loadMode && …}` branch already
     * handles, so `undefined` is a state the receipt was written for. */
    loadMode, readScope, readEvidence,
  } = useCategoryUniverse(category)
  const loading = status === 'loading'
  const supportRead = useMemo(() => supportedBookReadStatus({data:universe,readEvidence,complete,status}), [universe,readEvidence,complete,status])

  /* THE LAST HUNT (Brian 2026-10-26): "i dont see on a daily basis the last
   * hunt". One read of /api/hunt/last-run, and whether each of its crowns is
   * on a rep's worklist, decided by the worklist's own ranking over the
   * championship plane this page already holds. */
  const lastHunt = useLastHunt()
  const huntPlane = championships || []
  const huntPlaneComplete = championshipsComplete === true && championshipsStatus === 'done' && championshipsReadHealthy === true
  const lastHuntReach = useLastHuntReach(lastHunt.report, huntPlane, huntPlaneComplete)
  /* Opens the Activity panel on the last hunt. Where this view does not render
   * that panel, the same detail opens under the header, so the line is never
   * a button that does nothing. */
  const [huntInline, setHuntInline] = useState(false)
  const openLastHunt = () => {
    const d = document.getElementById('cc-landings-details')
    if (d) { d.open = true; d.scrollIntoView({ block: 'start' }); return }
    setHuntInline((v) => !v)
  }

  /**
   * THE CHEER ROLLUP — gym → team → championship, attached before anything else
   * reads the universe.
   *
   * A cheer GYM lives on the pursuit plane; the championships its TEAMS win live
   * on the 2-64425303 plane, which is already loaded in every space. This is the
   * only place the two meet: `attachCheerRollup` derives the team layer from the
   * crowned-team names, hangs each gym's titles under it, and stamps the
   * partnership state onto the record so every shared surface — the table, the
   * comparator, the CSV — reads it like any other field.
   *
   * It runs ONLY in the Cheer space. Every other space gets its universe
   * untouched, by reference, so nothing else pays for this.
   */
  const isCheer = isCheerPartnership(category)
  const { data, cheerRollup } = useMemo(() => {
    if (!isCheer) return { data: universe, cheerRollup: null }
    const { records, rollup } = attachCheerRollup(universe, championships || [])
    return { data: records, cheerRollup: rollup }
  }, [isCheer, universe, championships])

  const view = effectiveView || params.get('view') || (params.get('day') ? 'calendar' : defaultViewFor(category))
  const filters = useMemo(() => readBoardFilters(params, EMPTY_FILTERS), [params])
  const setFilters = useCallback(update => setParams(previous => writeBoardFilters(previous, update, EMPTY_FILTERS), { replace: true }), [setParams])
  const navigateIfChanged = useCallback(next => {
    // Returning the previous URLSearchParams from setParams still navigates.
    // Avoid the router call entirely, preserving location.key and draft review.
    if (next.toString() !== params.toString()) setParams(next)
  }, [params, setParams])
  const setView = useCallback(value => {
    if (view === value) return
    const next = new URLSearchParams(params); next.set('view', value); next.delete('page')
    navigateIfChanged(next)
  }, [params, view, navigateIfChanged])

  /* THE RECONCILIATION DEEP LINK. Kept OUT of `filters` on purpose: the filter
     bar's nine dimensions are things a rep sets by hand and clears by hand,
     and this is a set of record ids that arrived from another screen. Folding
     it in would put a filter in the bar that the bar cannot express, show, or
     clear — which is how a rep ends up looking at a narrowed board with no
     visible reason for it. It gets its own state, its own banner, and its own
     clear. */
  const [reconFilter, setReconFilter] = useState(null)
  const [drawer, setDrawer] = useState(null)               // universal detail drawer target
  /* ⚠️ THE INDIVIDUAL-TITLE LENS. Brian: "I also want to surface championships
   * for individuals at the conference level are crowned with a ring in college.
   * Think an SEC championship."
   *
   * Measured on the live object 2026-08-31: 2,716 conference-level records,
   * 1,405 of them individual sports — tennis, track, swimming, golf, cross
   * country, wrestling — and **zero crowned**. 124 conferences, 394 SEC
   * records. They were never missing; they were unfindable, because search is
   * AND-only and "every individual sport" is an OR across a dozen words.
   *
   * Each of these crowns MANY (see multiChampion.js), so the ring count is a
   * large multiple of 1,405 — deliberately not multiplied here, because a
   * made-up multiplier gets read as a quotable figure. */
  const individualOnly = params.get('individual') === '1'
  const setIndividualOnly = value => setParams(previous => {
    const next = new URLSearchParams(previous); if (value) next.set('individual', '1'); else next.delete('individual'); next.delete('page'); return next
  }, { replace: true })
  const [dossierTarget, setDossierTarget] = useState(null) // Champion-to-Close
  const [dossierSection, setDossierSection] = useState('overview')
  const [dossierArtworkProof, setDossierArtworkProof] = useState(null)
  const [artworkComposer, setArtworkComposer] = useState(null)
  const [artworkStatusRevision, setArtworkStatusRevision] = useState(0)
  useEffect(() => { setArtworkComposer(null) }, [location.key])
  const [crown, setCrown] = useState(null)                 // Submit-for-Win modal target
  const [crownBusy, setCrownBusy] = useState(false)
  const [crownError, setCrownError] = useState('')
  /* The SAME modal in its other mode. Separate state so a correction can never
   * be mistaken for a crown mid-flight — one writes a champion, one deliberately
   * does not. */
  const [correct, setCorrect] = useState(null)
  // The recognition / pursuit create flow — `{ kind, record }` or null.
  const [recognize, setRecognize] = useState(null)
  // THE GUIDED PATHWAY. Which step of the space's sequence the board is scoped
  // to ('' = all). This is the "who do I act on" control — see `PathwayBar`.
  const [step, setStep] = useState('')
  // The rep reassignment: which row is mid-write, and the last outcome.
  const [assignState, setAssignState] = useState({ busyId: null, error: '', notice: '' })
  const [bulk, setBulk] = useState({ busy: false, done: 0, total: 0 })

  /**
   * THE PER-ORG ACTION for this space — "Nominate Community Hero" on a police
   * or fire department, "Start pursuit" on a Greek organization. Null in every
   * other space, so no existing surface grows a button.
   *
   * The action is DESCRIBED here and enforced in `recognition.js`: the button
   * itself decides nothing, so one-active-hero-per-precinct is asserted against
   * the model rather than against a component.
   */
  const rowAction = useMemo(() => {
    if (isCommunityHero(category)) {
      return {
        kind: 'hero',
        label: `Nominate ${heroLabelFor(category)}`,
        columnLabel: 'Nominate',
        consoleTitle: `${heroLabelFor(category)} program`,
        heroLabel: heroLabelFor(category),
        honoreeNoun: honoreeNounFor(category),
        // What ONE of these records is called, lowercased, so the guided step
        // reads "this department's Community Hero" rather than "this record's".
        recordNoun: String(category.noun || 'department').toLowerCase(),
        onStart: (record) => { setDrawer(null); setRecognize({ kind: COMMUNITY_HERO, record }) },
      }
    }
    if (isGreekPursuit(category)) {
      return {
        kind: 'pursuit',
        label: 'Start pursuit',
        columnLabel: 'Pursuit',
        consoleTitle: 'Pursuit tracking',
        honoreeNoun: '',
        recordNoun: String(category.noun || 'organization').toLowerCase(),
        onStart: (record) => { setDrawer(null); setRecognize({ kind: GREEK_PURSUIT, record }) },
      }
    }
    // THE CHEER GYM PARTNERSHIP. Step 1 of the pathway is the only write here
    // too: opening a partnership pursuit against the gym. Every later step is a
    // human decision on that deal in HubSpot.
    if (isCheerPartnership(category)) {
      return {
        kind: 'partnership',
        label: 'Start partnership pursuit',
        columnLabel: 'Partnership',
        consoleTitle: 'Gym partnership',
        honoreeNoun: '',
        recordNoun: String(category.noun || 'gym').toLowerCase(),
        onStart: (record) => { setDrawer(null); setRecognize({ kind: CHEER_PARTNERSHIP, record }) },
      }
    }
    return null
  }, [category])

  /**
   * THE CREATE LANDED. The new deal only comes back through the backend's
   * association read on the next load, so the record is patched locally from
   * what the create actually RETURNED — the hero badge / pursuit row reflects
   * it immediately, and the record's next step advances to the following one.
   *
   * An idempotent re-submit (`created: false`) patches the same way: the deal
   * exists either way, which is the thing the board is meant to show.
   */
  const onRecognitionCreated = useCallback(({ record, patch }) => {
    if (record?.id && patch) patchLocal(record.id, patch)
  }, [patchLocal])

  /* A recorded champion repaints its row immediately, exactly as the bulk hunt
   * bar does. Without it the Champion column keeps reading "no champion yet"
   * next to one the rep just recorded — the two-sources-of-truth fault this
   * board has been bitten by before. Holds only what the server confirmed it
   * wrote; the next real load replaces it. */
  const onHunted = useCallback((id, { champion, sourceUrl } = {}) => {
    if (id) patchLocal(String(id), { current_champion: champion, champion_source_url: sourceUrl })
  }, [patchLocal])

  /* A WITHDRAWN CROWN REPAINTS THE SAME WAY — but from the fields the server
   * said it wrote, never from what we asked for. `clearPatch()` composes it
   * from the response's own `samples[].fields`, so a record whose write did not
   * land is not drawn as cleared.
   *
   * ⚠️ NORMALIZED KEYS. `onHunted` directly above patches `current_champion` /
   * `champion_source_url` — RAW HubSpot keys, which the normalized records in
   * `data` do not carry, so that patch has never actually repainted the
   * champion column. Left alone here because fixing it is a separate change
   * with its own testing, but this path must not copy it: `clearPatch` emits
   * `champion` / `championSourceUrl` / `story` / `summary`, which is what the
   * cells read. Noted so the next person does not "make them consistent" in
   * the wrong direction.
   *
   * The drawer holds its own copy of the record, so the open panel is patched
   * too — the same thing `assign` does. */
  const onCrownCleared = useCallback((id, patch) => {
    if (!id || !patch) return
    patchLocal(String(id), patch)
    setDrawer((d) => (d && String(d.id) === String(id) ? { ...d, ...patch } : d))
  }, [patchLocal])

  /* A CORRECTED FIELD REPAINTS THE SAME WAY, and under the same rule: only from
   * what the server CONFIRMED it wrote AND the record read back as holding.
   * `editPatch()` composes it in NORMALIZED keys — `name` / `sport` / `level` /
   * `segment` / `conference` / `state` / `championLocked` — which is what the
   * cells, the filters and the comparators read.
   *
   * ⚠️ IT DELIBERATELY EMITS NOTHING FOR `sr_event_date`. The board reads
   * `effDate`, which the normalizer derives as confirmed ?? event ?? projected;
   * mirroring a corrected event date onto it would require re-deriving that
   * precedence here, and getting it wrong would show a date the record does not
   * hold. `editPatch` returns null for that field and the next real load
   * carries it — see the note there. */
  const onFieldEdited = useCallback((id, patch) => {
    if (!id || !patch) return
    patchLocal(String(id), patch)
    setDrawer((d) => (d && String(d.id) === String(id) ? { ...d, ...patch } : d))
  }, [patchLocal])

  // Nationals above their chapters — the Greek space only.
  const groupNationals = isGreekPursuit(category)

  /* THE NON-SEARCH FILTERS. Separated from the query so the search engine can
   * report against the set the dropdowns actually left — telling somebody
   * "nothing says Ohio" when they also have a sport filter on would be a true
   * sentence about the wrong universe. */
  /* THE RECONCILIATION NARROWING, applied BEFORE the filter bar.
   *
   * ⚠️ IT IS APPLIED ONLY WHEN THE MEMBERSHIP HAS ACTUALLY ARRIVED. While it
   * is loading, and if it errored, the board shows EVERYTHING and the banner
   * says why. The alternative — rendering an empty board until the ids land —
   * would flash "nothing matches" at a reader who clicked a number, which is
   * the silent zero this entire readout exists to refuse. */
  const scoped = useMemo(() => {
    if (!reconFilter || reconFilter.status !== 'ready' || !reconFilter.ids) return data
    return data.filter((c) => reconFilter.ids.has(String(c.id)))
  }, [data, reconFilter])

  const selectedRepCoverageId = useMemo(() => coverageIdForRepName(data,filters.owner),[data,filters.owner])
  const narrowed = useMemo(() => scoped.filter((c) => {
    if (!matchesCoverageMember(c, filters.bowlMember)) return false
    if (category.source === 'championships' && filters.book === 'supported' && supportRead.available && !inSupportedBook(c, accessContext?.user)) return false
    if (category.source === 'championships' && filters.titleTier && titleTierFor(c).titleTier !== filters.titleTier) return false
    if (filters.sport && c.sport !== filters.sport) return false
    if (filters.industry && c.industry !== filters.industry) return false
    if (filters.level && c.level !== filters.level) return false
    if (filters.state && c.state !== filters.state) return false
    if (filters.product && c.product !== filters.product) return false
    /* ⚠️ "UNASSIGNED" IS A VALUE, NOT THE ABSENCE OF ONE.
     *
     * This line used to be the whole of the owner filter, and it could not
     * express the one cohort that matters most: the records nobody owns answer
     * `ownerName(c) === ''`, and `filters.owner === ''` is how this very line
     * says "no filter". The sentinel separates "ask for nobody" from "do not
     * ask", so the 2,399 records with no rep (measured 2026-10-13, off the
     * served snapshot, 15,814 records) become selectable instead of being a
     * condition somebody has to write a query for. See UNASSIGNED_FILTER. */
    if (filters.owner === UNASSIGNED_FILTER) { if (ownerName(c)) return false }
    else if (String(filters.owner || '').startsWith('school-team:')) { if (!matchesCoverageMember(c,filters.owner.slice(12))) return false }
    else if (filters.owner && ownerName(c) !== filters.owner && !(selectedRepCoverageId && matchesCoverageMember(c,selectedRepCoverageId))) return false
    if (filters.incumbent && c.incumbent !== filters.incumbent) return false
    if (filters.year && (!c.effDate || c.effDate.getFullYear() !== Number(filters.year))) return false
    return true
  }), [scoped, filters, selectedRepCoverageId, category.source, accessContext?.user, supportRead.available])

  /* ⚠️ EVERY WORD, ANYWHERE, IN ANY ORDER — AND IT NEVER RETURNS A SILENT ZERO.
   *
   * This was one literal substring test against a fixed concatenation, so the
   * query had to appear as a contiguous phrase in the order the fields happened
   * to be glued together: "baseball little league" returned NOTHING while
   * "little league baseball" returned a record. The champion was not
   * searchable at all, on a board whose job is finding champions.
   *
   * The worse half was the empty result. A bare "0 shown" let a rep conclude
   * the universe was missing an entire program when it was the phrasing that
   * missed. searchRecords now falls back to the closest records and NAMES the
   * word that excluded everything — see recordSearch.js. */
  /* The lens is applied BEFORE the query so the search note counts against
     what the lens left, not the whole board. */
  const lensed = useMemo(
    () => (individualOnly ? narrowed.filter((c) => multiChampion(c)) : narrowed),
    [narrowed, individualOnly]
  )
  const individualCount = useMemo(
    () => narrowed.reduce((n, c) => (multiChampion(c) ? n + 1 : n), 0),
    [narrowed]
  )
  const search = useMemo(
    () => searchRecords(lensed, filters.q, ownerName),
    [lensed, filters.q]
  )
  /* THE SHARED DATE FILTER (2026-10-26, [Jarvis · Claude]) — applied here, once,
   * so every view of every space searches by the same control. Each view
   * searches its OWN date (useBoardControls → dateFilter.js#ccSurfaceFor), and
   * a record with no date stays in the list unless the rep hides it. */
  const board = useBoardControls({ params, setParams, view, category, dated, demo, patchLocal, setDrawer })
  const dated$ = useMemo(
    () => applyDateFilter(search.results, board.dateFilter, board.dateSpec.dateOf, now),
    [search.results, board.dateFilter, board.dateSpec, now]
  )
  const filtered = dated$.rows

  /**
   * THE GUIDED SCOPE. `filtered` is what the filter bar left; `visible` is that
   * narrowed to ONE step of the pathway when the rep has picked one — "show me
   * only the departments that still need a hero".
   *
   * The two are kept separate on purpose: the pathway bar counts off `filtered`,
   * so selecting a step never collapses the other steps' counts to zero and the
   * rep can always see the whole sequence they are working through.
   */
  const stepOpts = useMemo(
    () => ({ heroLabel: rowAction?.heroLabel, honoreeNoun: rowAction?.honoreeNoun, noun: rowAction?.recordNoun }),
    [rowAction]
  )
  const visible = useMemo(
    () => (step ? filtered.filter((c) => nextStepFor(c, stepOpts)?.key === step) : filtered),
    [filtered, step, stepOpts]
  )

  // ONE selection for every view, keyed by record id and reconciled against
  // what is actually on screen — a row the filters or the active pathway step
  // have dropped can never be exported.
  const activeView = category.views.includes(view) ? view : defaultViewFor(category)
  const worklistScope = useWorklistScope(visible, activeView, now, category.source === 'championships')
  const selection = useRowSelection(worklistScope.rows)

  // Only the SELECTED space is loaded, so only it can carry an honest count.
  // The rail shows nothing for the others rather than a guess or a zero.
  const categoryCounts = useMemo(
    () => (pending || loading ? {} : { [categoryKey]: data.length }),
    [categoryKey, data.length, pending, loading]
  )

  const byState = useMemo(() => aggregateByState(visible), [visible])

  /* The three voices of a zero, resolved once per render from the scope the
   * backend declared — never guessed from the count. `null` on the happy path
   * for an unscoped caller, so the header stays quiet when there is nothing to
   * explain. */
  const compactChampionshipScope = category.source === 'championships' && complete && !loading && !error && !(filters.book === 'supported' && supportRead.error)
  const scopeNote = (
    <ScopeNote
      collapsible={!compactChampionshipScope}
      count={loading ? null : data.length}
      loading={loading}
      loadError={category.source === 'championships' ? (error ? String(error?.message || error) : filters.book === 'supported' ? supportRead.error : null) : error && !data.length ? String(error?.message || error) : scopeError}
      championshipRead={category.source === 'championships'}
      readScope={readScope}
      complete={complete}
      role={accessRole}
      bookMeta={bookMeta}
      book={accessBook}
      noun={category.nounPlural}
    />
  )
  // Which alarm buckets this space can honestly raise. Championships gets both
  // (`dated` and `champions` are true), so its Gaps tab is unchanged; a
  // corporate space drops NO DATE (every record is undated by definition) and
  // NO CHAMPION (a corporation never wins anything).
  const gapOpts = useMemo(
    () => ({ dated, champions: category.source === 'championships' }),
    [dated, category.source]
  )
  /* ⚠️ THE GAPS BADGE IS A COUNT OF RECORDS, NOT A SUM OF BUCKETS.
   *
   * It used to add the buckets together, and a record falls into as many
   * buckets as it has problems — no owner AND no champion AND no state is one
   * record counted three times. On the live object that rendered
   * **Gaps 55,516** against a universe of 14,805, under copy reading "the
   * records that cannot be worked… the number on the tab is how many."
   *
   * Filtered to 3 records it read 9, which is how the double-counting was
   * caught: 0 no-date + 3 no-owner + 3 uncovered + 1 no-champion + 2 no-state.
   * It held in every space — Cheer 519 records / 711, Greek 206 / 450.
   *
   * A number larger than the universe is not a rounding problem, it is a
   * different quantity wearing the label of this one. So: DISTINCT records in
   * at least one bucket. The per-bucket counts on the cards are unchanged —
   * there the overlap is the point. */
  const gapTotal = useMemo(() => {
    if (!data.length) return 0
    const ids = new Set()
    for (const b of gapBuckets(visible, now, gapOpts)) for (const it of b.items) ids.add(String(it.id))
    return ids.size
  }, [visible, now, data.length, gapOpts])

  /* The id set the Week Board is allowed to show, or null in the space that IS
   * the whole object. `recordFilter` is what makes a space a subset. */
  const weekScopeIds = useMemo(
    () => (category.recordFilter ? new Set(data.map((d) => String(d.id))) : null),
    [category, data]
  )

  /* THE STATUS LEGEND, PER SPACE.
   *
   * `LEGEND` is the CHAMPIONSHIP pursuit enum, and it was rendered verbatim in
   * every space: "Champion Crowned · Won · Outreach In Progress · To Pursue ·
   * Not Started" appeared in RFPs, Greek, Corporate, Police, Fire, Government,
   * Letterwinner and Cheer — "Champion Crowned" sitting directly beside "Needs
   * a Community Hero" in a space where nobody competes.
   *
   * Championships keeps the exact list, in order, unfiltered — it is the
   * canonical axis there, it documents the whole axis rather than today's data
   * (all 14,805 records currently sit at To Pursue), and the rail is required
   * to leave that surface byte-identical.
   *
   * A pursuit space instead names its OWN stages, read off the records
   * (`stageLabel` is the line's own word, kept beside the canonical enum by
   * pursuitAdapter). A line that carries no stage at all renders no legend,
   * rather than a colour key for an axis it does not have. */
  const legend = useMemo(() => {
    if (category.source === 'championships') {
      return LEGEND.map((k) => ({ key: k, label: PURSUIT_META[k].label, color: PURSUIT_META[k].color }))
    }
    const seen = new Map()
    for (const c of data) {
      const meta = c.pursuit && PURSUIT_META[c.pursuit]
      if (!meta) continue
      const label = c.stageLabel || meta.label
      if (!seen.has(label)) seen.set(label, meta.color)
    }
    return [...seen].map(([label, color]) => ({ key: label, label, color }))
  }, [category.source, data])

  const drawerReturnFocus = useRef(null)
  const openDrawer = useCallback((c, task = null, relatedChampionship = false) => {
    if (!document.activeElement?.closest('[role="dialog"]')) drawerReturnFocus.current = document.activeElement
    // The accepted URL is the only authority for replacing an open record.
    // A dirty/saving composer may cancel this navigation.
    const next = !c.sourceType&&!c.isIndyGroup ? campaignParams(params,{championshipId:c.id,section:typeof task==='string'&&task.startsWith('campaign')?task:'campaign'}) : closeCampaignParams(params)
    next.set('record',String(c.id))
    if(typeof task==='string'&&!task.startsWith('campaign'))next.set('work',task)
    // Related rows come from the full championship plane, not a same-ID
    // pursuit object. Persist their correct source so reload/Back resolve it.
    if(relatedChampionship&&!data.some(row=>!row.sourceType&&String(row.id)===String(c.id))){next.set('space','championships');next.delete('view')}
    navigateIfChanged(next)
  }, [params, data, navigateIfChanged])

  /* ⚠️ DEEP LINK TO ONE RECORD — `/command-center?record=<id>`.
   *
   * Home's worklists listed championships and orders a rep should act on and
   * every row was inert, because there was nowhere for a row to point: the
   * board could only be entered at the top. The card header linked to the
   * module, which is the same as not linking to the record at all.
   *
   * It also makes a championship shareable and bookmarkable, which matters
   * most on a phone — a rep can send a colleague the record rather than
   * "open the Command Center and search for it".
   *
   * The param is cleared when the drawer closes so Back does not reopen it,
   * and it waits for the universe: the id may arrive before the record does,
   * over ~134 pages. */
  /* ⚠️ THE DEEP LINK NOTHING CONSUMED. `commandCenterHref` emits
     ?conference=…&view=… and this page only ever read `record`, so every
     "Open in Command Center" from Governing Bodies landed on the DEFAULT board
     — which is exactly what Brian saw. I wrote the link and never wired the
     other end; a link that silently ignores its own parameters is worse than no
     link, because it looks like it worked.

     Applied ONCE, on mount. A live effect would fight the user every time they
     changed a filter, since the URL still carries the arrival parameters. */
  const reconciliationId = params.get('filter')
  useEffect(() => {
    setReconFilter(reconciliationId ? { status: 'loading', id: reconciliationId, ids: null, error: '' } : null)
  }, [reconciliationId])

  /* FETCH THE MEMBERSHIP for an arrived reconciliation filter.
   *
   * ⚠️ EVERY FAILURE MODE HERE IS LOUD. An unknown filter is a 400 from the
   * route naming the valid ids — never an empty list, because an empty board
   * would read as "the backlog is cleared". An unreachable route is an error
   * banner, never an unfiltered board rendered as though the link worked.
   * Those two are the whole reason this is a fetch rather than a predicate. */
  useEffect(() => {
    if (!reconFilter || reconFilter.status !== 'loading') return
    let live = true
    api.reconciliationRecords(reconFilter.id)
      .then((r) => {
        if (!live) return
        setReconFilter({
          status: 'ready', id: r.filter || reconFilter.id,
          ids: new Set((r.ids || []).map(String)),
          n: r.n, complete: r.complete !== false, measuredAt: r.measuredAt, error: '',
        })
      })
      .catch((e) => {
        if (!live) return
        setReconFilter({
          status: 'error', id: reconFilter.id, ids: null,
          error: e?.body?.message || e?.message || 'The record list could not be read.',
          valid: e?.body?.valid || null,
        })
      })
    return () => { live = false }
  }, [reconFilter])

  const wantedId = params.get('record')
  const previousDrawerId = useRef(null)
  useEffect(() => {
    const wasOpen = previousDrawerId.current
    previousDrawerId.current = wantedId
    if (!wantedId) {
      setDrawer(null)
      if (wasOpen) requestAnimationFrame(() => { if (drawerReturnFocus.current?.isConnected) drawerReturnFocus.current.focus({preventScroll:true}) })
      return
    }
    if (dossierTarget || crown || correct || recognize) return
    const rec = data.find((x) => String(x.id) === String(wantedId))
    setDrawer(current => rec ? (String(current?.id) === String(wantedId) ? current : rec) : null)
  }, [wantedId, data, dossierTarget, crown, correct, recognize])
  /* The Calendar's selected day, in the URL. `replace` so paging through days
   * does not fill the Back button with a stack of dates; clearing removes the
   * param rather than leaving `?day=`. */
  const selectDay = useCallback((key) => {
    const next = new URLSearchParams(params)
    if (key) next.set('day', key)
    else next.delete('day')
    setParams(next, { replace: true })
  }, [params, setParams])

  const closeDrawer = useCallback(() => {
    // URL navigation must pass the active composer blocker before unmount.
    if (params.get('record')) {
      const next = closeCampaignParams(params)
      setParams(next, { replace: true })
    } else setDrawer(null)
  }, [params, setParams])

  // A space only renders the views it declares. When the selected view isn't
  // one of them (a date-driven view carried over from Championships), the
  // space's first view is used — derived, so there is no frame where a pursuit
  // universe is rendered through a championship-only view.

  // Switching space is a hard re-scope: filters built from the previous
  // universe would filter this one to nothing, and an open drawer would be
  // showing a record the page no longer holds.
  const changeCategory = useCallback((key) => {
    setParams(previous => {
      const next = new URLSearchParams(previous)
      for (const name of [...Object.keys(EMPTY_FILTERS), 'record', 'page', 'view', 'filter', 'conference', 'individual', 'queueFocus', 'queueSort','work','act','artworkProof','campaignJob','campaignIntent','campaignEmailMode','campaignContactQ','periods']) next.delete(name)
      next.set('space', key); return next
    })
  }, [setParams])
  // Clear space-local controls only after the router accepted the change.
  const acceptedSpace = useRef(category.key)
  useEffect(() => {
    if (acceptedSpace.current === category.key) return
    acceptedSpace.current = category.key
    setDossierTarget(null)
    setCrown(null)
    setCorrect(null)
    setRecognize(null)
    // The pathway is per-space — step 1 of Greek is not step 1 of Police.
    setStep('')
    setAssignState({ busyId: null, error: '', notice: '' })
  }, [category.key])

  // Action-console routing (from the drawer).
  const openDossier = (c,section='overview') => { setDossierArtworkProof(null); if (!c?.id || c.isIndyGroup) return; if (splitParentSummary(c)) { setDossierTarget(null); setDrawer(c); return } setDrawer(null); setDossierSection(section); setDossierTarget(c) }
  const onCreateArt = c => {if(c?.id&&!c.isIndyGroup)openDrawer(c,'campaign-artwork')}
  const onCampaign = c => {if(c?.id&&!c.isIndyGroup)openDrawer(c,'campaign-email')}
  /* The ACCOUNT, not whoever is stored as champion: on an individual title the
   * champion can be an athlete and the school is who buys (2026-10-26). One
   * helper, shared with the Work queue row and My Worklist. */
  const onQuote = c=>openDossier(c) // Review the real dossier; never bypass title or artwork pricing gates.
  // The legacy unsourced crown endpoint rejects named winners before writes.
  // This action reviews existing evidence; it never promises or attempts re-crowning.
  const onSubmitWin = (c) => {
    if (!c?.id || c.isIndyGroup) return
    setCrown(null)
    if (splitParentSummary(c)) { setDossierTarget(null); setDrawer(c); return }
    openDossier(c)
  }
  const onCorrect = (c) => { setDrawer(null); setCorrect(c) }

  /* ⭐ THE WORKLIST'S DOOR INTO THE ACTION CONSOLE - `?record=<id>&act=art|
   * email|win`. My Worklist offers Art / Email / Win on every crowned row
   * (2026-10-26); rather than a second copy of the dossier and crown modal, it
   * links here and this runs the SAME handler the drawer's console runs, once
   * the record has arrived, then clears `act` so Back does not re-fire it.
   * Write actions only where the write exists - the same `writes` gate. */
  const wantedAct = params.get('act')
  useEffect(() => {
    if (!wantedAct || !wantedId) return
    const rec = data.find((x) => String(x.id) === String(wantedId))
    if (!rec) return
    const run = { art: onCreateArt, quote: onQuote, email: onCampaign, win: onSubmitWin }[wantedAct]
    if(wantedAct==='dossier')onCreateArt(rec)
    else if (writes && run) run(rec)
    /* `record` stays, as it does when the drawer's own console fires: closing
     * the dossier or the crown modal lands back on the record. */
    setParams((previous) => { const next = new URLSearchParams(previous); next.delete('act'); return next }, { replace: true })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantedAct, wantedId, data, writes])

  /* ---- REASSIGN (the only write the assignment engine leads to) --------
   *
   * The engine proposes; this writes, and only from a human click. It sets
   * `sr_assigned_rep` — the display name — because 13 of the 15 reps are not
   * HubSpot owners, so `hubspot_owner_id` would silently drop them.
   *
   * A human MAY override an existing owner: that is what a reassignment is.
   * The from → to pair goes to `request()` as audit context, so the trail
   * records what changed rather than only what was asked for.
   */
  const assign = useCallback(async (record, rep, reason) => {
    if (!record?.id || !rep) return { ok: false }
    // The gate is re-decided here, not just at the button: a control that
    // renders is not authorization. A cheer lane delegate passes only for a
    // lane record moving to a lane member; the server re-decides both.
    if (!manageAssignments.allowed) {
      const mode = pickerMode(manageAssignments, laneDelegation, record)
      if (mode.mode !== 'lane' || !laneDestinationOk(laneDelegation.lane, rep)) {
        setAssignState({ busyId: null, error: mode.why || manageAssignments.why, notice: '' })
        return { ok: false }
      }
    }
    /* The reason is checked HERE as well as at the picker, for the same reason
     * the gate is: the control disabling itself is a courtesy, not a
     * guarantee. Without this, a caller that forgets the third argument sends
     * `reason: undefined` and gets the 400 all over again — the exact bug this
     * change exists to fix, reintroduced by a call site. */
    const reasonText = String(reason ?? '').trim()
    if (!reasonText) {
      setAssignState({
        busyId: null,
        notice: '',
        error: 'Nothing was assigned, because an assignment needs a reason. '
          + 'Type a short reason for the change and assign again. It is written to the permanent audit ledger.',
      })
      return { ok: false }
    }
    const from = currentRep(record)
    setAssignState({ busyId: record.id, error: '', notice: '' })
    try {
      if (!demo) await api.assignRep(record.id, rep, reasonText, assignmentAudit(record, rep))
      patchLocal(record.id, { rep })
      // The drawer holds its own copy of the record, so patching the universe
      // alone would leave the open panel reading the old owner.
      setDrawer((d) => (d && d.id === record.id ? { ...d, rep } : d))
      setAssignState({
        busyId: null,
        error: '',
        notice: `${record.name} → ${rep}${from ? ` (was ${from})` : ''}.`,
      })
      return { ok: true }
    } catch (err) {
      /* ⚠️ NEVER `err.message || 'Could not assign the rep.'`.
       *
       * That fallback is a bare failure: it fires precisely when the error was
       * least legible, and answers the person's only question — WHY — with a
       * restatement of what they already saw. A permission refusal, a dropped
       * connection and a rejected field each need a different next move from
       * the person, so each has to read differently. `explainAssignFailure()`
       * is total and always produces a named cause and an action. */
      const failure = explainAssignFailure(err, { recordName: record.name, rep })
      setAssignState({ busyId: null, error: failure.message, errorKind: failure.kind, notice: '' })
      return { ok: false, failure }
    }
  }, [demo, patchLocal, manageAssignments, laneDelegation])

  /**
   * BULK REASSIGN — one rep, every ticked row. Sequential on purpose: 100
   * parallel writes against HubSpot is how you get rate-limited into a partial
   * result nobody can reconstruct. Each row is written and patched
   * individually, so a failure halfway through leaves the successful ones
   * correct and reports exactly how many landed.
   */
  const bulkAssign = useCallback(async (rows, rep, reason) => {
    if (!rows?.length || !rep) return
    if (!manageAssignments.allowed) {
      /* A lane delegate's bar already removed rows outside the lane; this
       * re-checks rather than trusting it, and refuses the whole batch if any
       * row would be refused, so nothing half-lands. */
      const lane = laneDelegation?.allowed ? laneDelegation.lane : null
      const split = lane ? partitionForLane(lane, rows, rep) : null
      if (!split || split.skip.length) {
        setAssignState({ busyId: null, notice: '',
          error: split?.skip[0]?.why || manageAssignments.why })
        return
      }
    }
    const reasonText = String(reason ?? '').trim()
    if (!reasonText) {
      setAssignState({
        busyId: null,
        notice: '',
        error: `Nothing was reassigned, because a bulk reassignment needs a reason. `
          + 'Type a short reason for the change and run it again. It is written to the permanent audit ledger '
          + 'against every record in the batch.',
      })
      return
    }
    setBulk({ busy: true, done: 0, total: rows.length })
    let done = 0
    /* ⚠️ COUNT THE ERRORS, DON'T JUST TALLY THEM.
     *
     * The old loop did `catch { failed += 1 }` and reported "N of M could not
     * be written" — which is the bulk-sized version of "failed". It threw away
     * the only thing that would tell anyone what to do next, and it looked
     * identical whether the cause was a missing grant (ask an exec), a dropped
     * connection (retry) or a rejected field (fix the input). Keeping the
     * errors costs one array and turns the summary into something actionable. */
    const errors = []
    for (const r of rows) {
      try {
        if (!demo) await api.assignRep(r.id, rep, reasonText, assignmentAudit(r, rep))
        patchLocal(r.id, { rep })
        setDrawer((d) => (d && d.id === r.id ? { ...d, rep } : d))
        done += 1
      } catch (err) {
        errors.push(err)
      }
      setBulk({ busy: true, done: done + errors.length, total: rows.length })
    }
    setBulk({ busy: false, done: 0, total: 0 })
    selection.clear()
    const failure = explainBulkFailures(errors, { total: rows.length, done, rep })
    setAssignState({
      busyId: null,
      error: failure ? failure.message : '',
      errorKind: failure ? failure.kind : null,
      notice: done
        ? `${done.toLocaleString()} record${done === 1 ? '' : 's'} reassigned to ${rep}.`
        : '',
    })
  }, [demo, patchLocal, manageAssignments, laneDelegation, selection])

  /* ---- CORRECT A RECORD ------------------------------------------------
   *
   * `POST /api/champion-update` with an allowlisted field set. It writes NO
   * champion — that is the whole distinction from the crown above, and it is
   * why the two have separate handlers rather than one with a flag: a single
   * handler that branched on mode is one edit away from writing a champion on
   * a correction.
   *
   * This existed on the backend and in CrownModal and had no way in. See
   * check-doors.mjs. */
  const submitCorrection = async (fields) => {
    setCrownBusy(true)
    setCrownError('')
    try {
      if (!demo) await api.championUpdate({ id: correct.id, ...fields })
      patchLocal(correct.id, {
        pursuit: fields.sr_pursuit_status || correct.pursuit,
        owner: fields.sr_assigned_rep ?? correct.owner,
      })
      setCorrect(null)
    } catch (err) {
      setCrownError(err?.message || 'Could not correct the record.')
    } finally {
      setCrownBusy(false)
    }
  }

  const submitCrown = async (fields) => {
    setCrownBusy(true)
    setCrownError('')
    try {
      if (!demo) await api.championWrite({ id: crown.id, ...fields })
      patchLocal(crown.id, {
        champion: fields.current_champion || crown.champion,
        dateStatus: 'Confirmed',
        dateConfidence: fields.sr_confirmed_date ? 'confirmed' : crown.dateConfidence,
      })
      setCrown(null)
    } catch (err) {
      setCrownError(err?.message || 'Could not record the champion.')
    } finally {
      setCrownBusy(false)
    }
  }

  return (
    <div className="fade-up" data-dense-view="command-center">
      <div className={styles.compactHeader}><PageHeader
        title="Command Center"
        lead="Find a record. Take the next action."
        actions={
          <span className={styles.readonly} data-testid="cc-live-count">
            <span className={styles.readonlyDot} data-live={!loading && !pending} />
            {pending
              ? `${category.label} · data being fed in`
              : demo
                ? `Demo data · ${data.length.toLocaleString()} records`
                : loading
                  ? `Loading… ${loadedCount.toLocaleString()} records`
                  : `Live · ${data.length.toLocaleString()} ${category.nounPlural}${complete && category.source === 'championships' ? ' (full object)' : ''}`}
            {/* ⚠️ THE READ TIME, ON THE COUNT ITSELF. Not in a panel, not on
                hover — beside the number, because the number is what gets
                screenshotted, pasted into a message and quoted back as the state
                of production hours later. `asOf.cached` is the honest word for a
                snapshot older than the request that asked for it. */}
            {!demo && !loading && asOf?.asOf && (
              <span className={styles.asOfStamp} title={`Snapshot built ${asOf.asOf}`}>
                {' · read '}{formatReadAge(asOf)}
              </span>
            )}
            {!demo && !loading && !asOf?.asOf && (
              <span className={styles.asOfStamp}>{' · read time not reported'}</span>
            )}
          </span>
        }
      />
      {/* THE LAST HUNT, ON THE HEADER, beside the count it explains. Tapping
          it opens the Activity panel on that run's crowns. */}
      {!demo && <LastHuntLine state={lastHunt} reach={lastHuntReach} onOpen={openLastHunt} />}
      {!demo && huntInline && <LastHuntDetail state={lastHunt} reach={lastHuntReach} />}
      </div>

      {/* ⚠️ A ZERO THAT CANNOT SAY WHY IT IS ZERO IS THE DEFECT. Three facts
          used to paint the same confident digit — "we hold none of these",
          "this view was scoped to you", and "we could not load this" — and a rep
          seeing zeros concluded the system was empty. It is not: 15,103 records,
          11,312 assigned, measured 2026-10-02T03:00:09Z.

          The verdict is NEVER inferred from the count. It comes from `bookMeta`,
          which /api/access/me has always sent and this client used to discard,
          and from a real load error. See lib/emptyReason.js and
          verify-empty-reason.mjs.

          Rendered as a SIBLING rather than a PageHeader prop: PageHeader takes
          `{ eyebrow, title, lead, actions }` and nothing else, so passing a
          `note` would have been silently dropped by React and this whole fix
          would have shipped rendering nothing — which is the same class of
          silent no-op as the discarded bookMeta it exists to surface. */}
      {!demo && !compactChampionshipScope && scopeNote}

      {demo && (
        <div className={styles.demoBanner}>
          <strong>Demo data</strong> — fictional records for layout preview (<code>?demo=1</code>). Live data loads without this flag.
        </div>
      )}

      {/* THE CATEGORY RAIL — every space, rendered from the registry. */}
      <CategoryRail value={categoryKey} onChange={changeCategory} counts={categoryCounts} />

      {/* The honest empty card belongs to the pursuit spaces. Championships
          never routes through it — an empty championship object renders the
          board exactly as it always did. */}
      {activeView === 'artworkcreated' ? <>
        <RepViewNavigation views={views} activeView={activeView} onChange={setView} gapTotal={gapTotal}/>
        <ArtworkCreated refreshToken={artworkStatusRevision}
            onOpenRecord={row=>openDrawer(row.record)}
            onPrepare={(row,proof)=>{setDossierTarget(null);setDrawer(null);setArtworkComposer({row,proof,locationKey:location.key})}}/>
      </> : pending || (category.source === 'pursuits' && !loading && status !== 'error' && !data.length) ? (
        <SpaceEmpty
          category={category}
          reason={pending ? 'pending' : 'empty'}
          error={error}
          onRetry={reload}
        />
      ) : status === 'error' ? (
        <div className={`card ${styles.errorBox}`}>
          <div className={styles.errorTitle}>Couldn’t load {category.nounPlural}</div>
          <p className={styles.errorMsg}>{error}</p>
          <button className="btn btn-primary" onClick={reload}>Retry</button>
        </div>
      ) : (
        <>
          {loading && (
            <div className={styles.loadingBar}>
              <span className={styles.spinner} />
              {category.source === 'championships' ? (
                /* ⚠️ SAY WHICH PATH IS RUNNING. This used to read "Paging the
                 * HubSpot cursor to exhaustion" unconditionally, which stayed on
                 * screen after the one-request snapshot shipped — so the slow
                 * path and the fast path looked identical to whoever was
                 * waiting, and a silent fall back to 148 requests was
                 * indistinguishable from normal. */
                building ? (
                  <>
                    Building the championship snapshot on the server —
                    {' '}{building.records.toLocaleString()} records read
                    {building.elapsedSeconds ? ` in ${building.elapsedSeconds}s` : ''}. This happens once after a deploy;
                    every load for the next few minutes is a single request.
                  </>
                ) : (
                  <>
                    Loading the full universe — {loadedCount.toLocaleString()} records so far.
                  </>
                )
              ) : (
                <>
                  Loading the {category.label} universe — {loadedCount.toLocaleString()} records so far. Paging the
                  {' '}{category.line} line’s cursor to exhaustion; views fill in as pages arrive.
                </>
              )}
            </div>
          )}

          {!loading && status === 'done' && !complete && (
            <div className={styles.loadDegraded} role="alert" aria-label="Incomplete record load">
              <strong>Partial results.</strong> Search covers only the records loaded so far. {error || 'The full record load did not finish.'}
              <button className="btn" onClick={reload}>Retry full load</button>
            </div>
          )}

          {/* ⚠️ A DEGRADED LOAD ANNOUNCES ITSELF. The board silently walking
              HubSpot 148 times is exactly how a shipped performance fix stayed
              broken in production — it looked like the page was merely slow. */}
          {!loading && degraded && (
            <div className={styles.loadDegraded} role="status">
              <strong>This loaded the slow way.</strong> {degraded}
            </div>
          )}

          {/* ⚠️ A NARROWED BOARD MUST SAY WHY IT IS NARROWED, and offer the way
              out. A rep arriving on 2,002 of 16,002 records (both measured
              2026-10-18) with no visible reason has been handed a board that
              looks broken; the filter bar
              cannot show this scope because the bar has no such dimension, so
              the banner is the only place it can be stated. Rendered for every
              state including the failures, because "loading" and "errored"
              both mean the board in front of you is NOT the subset you asked
              for, and that is the thing you must not have to guess. */}
          {reconFilter && (
            <div className={styles.reconScope} role="status">
              {reconFilter.status === 'ready' && (
                <>
                  <strong>Showing {scoped.length.toLocaleString()} records</strong>
                  {' '}from the reconciliation row <code>{reconFilter.id}</code>
                  {typeof reconFilter.n === 'number' && scoped.length !== reconFilter.n && (
                    /* The readout measured N; this board holds fewer. Not an
                       error — the board may not have paged everything yet —
                       but it is never silently hidden, because a count that
                       disagrees with its own link is the exact defect this
                       whole change was made to remove. */
                    <> {' '}— the readout measured <strong>{reconFilter.n.toLocaleString()}</strong>;
                      {' '}the board is holding {scoped.length.toLocaleString()} of them.</>
                  )}
                  {reconFilter.complete === false && <> {' '}⚠️ That list is a FLOOR, not a total.</>}
                </>
              )}
              {reconFilter.status === 'loading' && (
                <><strong>Loading the records behind that number…</strong> the board below is
                  showing EVERYTHING until they arrive, not an empty result.</>
              )}
              {reconFilter.status === 'error' && (
                <><strong>That link could not be resolved.</strong> {reconFilter.error}
                  {' '}The board below is UNFILTERED — it is not an empty backlog.
                  {reconFilter.valid && <> Valid rows: {reconFilter.valid.join(', ')}.</>}
                </>
              )}
              {' '}
              <button type="button" className={styles.reconClear} onClick={() => {
                setReconFilter(null)
                const next = new URLSearchParams(params)
                next.delete('filter')
                setParams(next, { replace: true })
              }}>Clear</button>
            </div>
          )}

          <div className={styles.filterRow}>
            <div className={styles.filterRowMain}>
              <FilterBar
                titleTiers={category.source === 'championships'}
                championshipBooks={category.source === 'championships'}
                scopeSummary={!demo && compactChampionshipScope ? championshipReadSummary(readScope, data.length) : null}
                scopeDetails={!demo && compactChampionshipScope ? scopeNote : null}
                supportBookAvailable={supportRead.available}
                supportBookError={supportRead.error}
                all={scoped}
                filters={filters}
                setFilters={setFilters}
                resultCount={visible.length}
                nounPlural={category.nounPlural}
                empty={EMPTY_FILTERS}
                searchNote={search.note}
                searchMode={search.mode}
                individualOnly={individualOnly}
                onIndividualOnly={setIndividualOnly}
                individualCount={individualCount}
                loading={loading}
                actions={<><ExportCsv
              items={worklistScope.rows}
              scopeLabel={worklistScope.label}
              total={data.length}
              filters={filters}
              now={now}
              viewLabel={views.find((v) => v.key === activeView)?.label || ''}
              selected={selection.selected}
              onClearSelection={selection.clear}
              nounPlural={category.nounPlural}
              noun={spaceNoun.singular}
              title={exportTitleFor(category)}
              slug={category.key}
              dateLabel={dateLabel}
              /* An export taken mid-load is a QUARTER of the departments in a
                 file that looks complete. The button says so, and the modal
                 repeats it, rather than leaving the honest banner to be the
                 only warning. */
              loading={loading}
              incomplete={!complete}
            /><a href="#cc-research">Research tools ↓</a></>}
              />
            </div>
            {/* Live selection count — the same number Export selected writes. */}
            {selection.count > 0 && (
              <div className={styles.selBar}>
                <span className={styles.selCount}>{selection.count.toLocaleString()}</span>
                selected
                <button type="button" className={styles.selClear} onClick={selection.clear}>Clear</button>
              </div>
            )}
            {/* Export the CURRENT filtered scope (plus a date range on the
                effective event date) as a CSV — the full set, not the page.
                Ticked rows narrow it to exactly those records instead. */}

          </div>

          {/* BULK REASSIGN — one rep onto every ticked row. Championship-space
              only, because `sr_assigned_rep` is written against 2-64425303 and
              no pursuit row has one. Hidden until something is selected, and
              read-only (with its reason) for anyone without the permission. */}
          {writes && (
            <BulkAssignBar
              selection={selection}
              gate={manageAssignments}
              onBulk={bulkAssign}
              busy={bulk.busy}
              progress={bulk.total ? `${bulk.done}/${bulk.total}` : null}
            />
          )}
          {(assignState.notice || assignState.error) && (
            <div className={styles.assignNote} data-tone={assignState.error ? 'error' : 'ok'}
              /* The cause travels with the message so this surface can be read
                 by eye AND by anything that later wants to count how reps are
                 actually failing — permission, transport or validation. */
              data-kind={assignState.errorKind || undefined} role="status">
              {assignState.error || assignState.notice}
            </div>
          )}

          {/* THE GUIDED PATHWAY — the sequence this space runs on, with how many
              organizations are sitting at each step and the step the rep is
              scoped to. This is the "feed them" surface: a Police space opens on
              "342 departments need a Community Hero", not on a table of 26,000
              rows. Only in a space that HAS a pathway (police / fire / greek);
              `rowAction` is null everywhere else, including Championships. */}
          {rowAction && (
            <PathwayBar
              records={filtered}
              kind={category.kind}
              action={rowAction}
              value={step}
              onSelect={setStep}
            />
          )}

          {/* Color legend: pursuit / win-loss-in-contention axis + sport accent note.
              ⚠️ ONLY THE CHAMPIONSHIPS SPACE MAY SAY "CHAMPION CROWNED".
              This rendered the fixed championship enum in all ten spaces, so
              "Champion Crowned · Won" sat beside "Needs a Community Hero" in the
              Police space and above a list of RFP close dates. See `legend`. */}
          {/* View tabs — only the views this space can honestly render. The
              date-driven ones are absent from a pursuit space because a
              company/deal pursuit row carries no event date. */}
          <RepViewNavigation views={views} activeView={activeView} onChange={setView} gapTotal={gapTotal}/>

          {/* ⚠️ EVERY VIEW IS BOUNDED, and the Hunted tab is why.
            *
            * React unmounts the WHOLE TREE when a render throws, so a single bad
            * field in one view took down the entire Command Center — the rail,
            * the filters, the other nine tabs, all of it, with no message. Brian
            * got a dead screen and no way to tell which tab was at fault.
            *
            * The boundary is keyed on `activeView`, which matters: without the
            * key React reuses the same boundary instance across tab switches, so
            * once one view threw, its error state would persist and every OTHER
            * tab would render the failure card too. Keying resets it on each
            * switch, so a broken view costs exactly itself.
            *
            * This does not fix the bug underneath — it makes it legible and
            * survivable, which is the difference between "the Command Center is
            * down" and "the Hunted tab needs a look". */}
          {/* What this tab is FOR — see viewUse() in categories.js. It sits under
            * the bar rather than in a tooltip because the rep who needs it is the
            * one who has not found the tab yet, and a tooltip only helps someone
            * already hovering the right thing. */}
          {viewUse(activeView) && <p className={styles.viewUse}>{viewUse(activeView)}</p>}

          {activeView !== 'map' && activeView !== 'manager' && activeView !== 'artworkcreated' && (
            <DateFilter compact={activeView === 'queue'} value={board.dateFilter} onChange={board.setDateFilter} label={board.dateSpec.label}
              summary={dated$.summary} noun={category.nounPlural || 'records'} id="cc-date" />
          )}

          <ErrorBoundary key={activeView} label={`The ${activeView} view`} onReset={() => setView('stages')}>

          {activeView === 'stages' && (
            <PursuitStages
              items={visible}
              now={now}
              onOpen={openDrawer}
              /* Write actions exist only where the write exists. */
              actions={writes ? { onCreateArt, onCampaign, onQuote, onSubmitWin } : {}}
              selection={selection}
              noun={category.noun}
              dateLabel={dateLabel}
            />
          )}
          {/* THE CHEER SPACE'S OWN VIEW — the gym-partnership pipeline, the
              team/title hierarchy under each gym, and the one next step per
              gym. Declared by the Cheer entry alone, so no other space can
              render it. `onOpenTitle` opens a linked CHAMPIONSHIP record in the
              same read-only drawer — the crown console stays championship-only
              (`writes` is false here), so nothing can be written from a gym. */}
          {/* THE WORK ORDER — the cheer space opens here. Same universe as the
              partnership board, ordered by evidence instead of by name. */}
          {activeView === 'workorder' && (
            <CheerWorkOrder items={visible} onOpen={openDrawer} rowAction={rowAction} />
          )}
          {activeView === 'partnership' && (
            <CheerGyms
              items={visible}
              now={now}
              onOpen={openDrawer}
              onOpenTitle={openDrawer}
              rowAction={rowAction}
              rollup={cheerRollup}
              noun={category.noun}
            />
          )}
          {activeView === 'queue' && <OpportunityQueue items={visible} now={now} onOpen={openDrawer} noun={category.noun} loading={loading} complete={complete} champions={category.source === 'championships'} actions={writes ? { onCreateArt, onCampaign, onQuote, onSubmitWin } : {}} onClear={() => setParams(previous => { const next = writeBoardFilters(previous, EMPTY_FILTERS, EMPTY_FILTERS); next.delete('individual'); next.delete('queueFocus'); return next }, { replace: true })} />}
          {activeView === 'board' && <PursuitBoard items={worklistScope.rows} sharedSort={category.source === 'championships' ? campaignSort(params) : null} onSharedSort={category.source === 'championships' ? update => setParams(previous => writeCampaignSort(previous, update)) : null} now={now} onOpen={openDrawer} noun={category.noun} dateLabel={dateLabel} dated={dated} groupNationals={groupNationals} rowAction={rowAction}
            onMove={writes ? board.moveCard : null} actions={writes ? { onCreateArt, onCampaign, onQuote, onSubmitWin } : null} />}
          {/* HUNTED — what the hunt has found, kept. Reads the provenance the
              hunt writes onto each record, so it survives a refresh rather than
              living in a bar that empties. */}
          {activeView === 'hunted' && <HuntedBoard items={visible} onOpen={openDrawer} onAccepted={onHunted} />}
          {activeView === 'gaps' && <GapsBoard items={visible} now={now} onOpen={openDrawer} selection={selection} noun={category.noun} dateLabel={dateLabel} dated={dated} linkLabel={linkLabel} gapOpts={gapOpts} groupNationals={groupNationals} rowAction={rowAction} suggest={writes} />}
          {/* THE ASSIGNMENTS WORKLIST — the engine's proposals, the seeded
              no-rep accounts, and the only surface that writes an owner.
              Championship-space only (see `CHAMPIONSHIP_VIEWS`). */}
          {/* ⚠️ PREPARATION, RANKED. Brian: "the challenge of crowning a champion
              but doing so with preparation. its the reason this has to be
              done." Every other piece of this build is a column in here. */}
          {activeView === 'readiness' && (
            <Readiness rows={visible} now={now} onOpen={openDrawer} />
          )}

          {activeView === 'assignments' && (
            <Assignments
              items={visible}
              onOpen={openDrawer}
              selection={selection}
              gate={manageAssignments}
              onAssign={assign}
              busyId={assignState.busyId}
              noun={category.noun}
              ruleRun={category.key === 'championships' && accessRole === 'exec' && !demo ? {
                complete,
                onVerified: (changes) => { for (const { id, fields } of changes) {
                  const record = universe.find(row => row.id === id)
                  patchLocal(id, { rep: fields.sr_assigned_rep ?? record?.rep,
                    raw: { ...record?.raw, ...fields } })
                } },
              } : null}
            />
          )}
          {activeView === 'worklist' && <Worklist items={visible} activePeriods={worklistScope.active} onPeriodsChange={worklistScope.setActive} now={now} onOpen={openDrawer} selection={selection} noun={category.noun} dateLabel={dateLabel} />}
          {activeView === 'calendar' && (
            <CountdownCalendar
              enableRepCalendar={category.source === 'championships'}
              items={visible}
              now={now}
              onOpen={openDrawer}
              noun={category.noun}
              dateLabel={dateLabel}
              selection={selection}
              /* THE SELECTED DAY LIVES IN THE URL, like `record` above, so a
                 date is linkable — "everything on Aug 12" is a link you can
                 send, not a click somebody has to be talked through. */
              selectedDay={params.get('day') || ''}
              onSelectDay={selectDay}
            />
          )}
          {activeView === 'justwon' && <JustWon items={visible} now={now} onOpen={openDrawer} />}
          {activeView === 'manager' && <ManagerRollup
            items={visible}
            now={now}
            nounPlural={spaceNoun.plural}
            /* Tapping a breakdown bar scopes the board to that slice — the
               question a rollup row actually raises. */
            onSlice={(field, value) => setFilters((prev) => ({ ...prev, [field]: value }))}
            /* ⭐ A REP ROW OPENS THEIR BOOK. Brian: *"When I go into manager and
               see the reps I cannot do anything wise like click on them."* The
               row was a bare `<tr>` with no handler at all.

               ⚠️ IT REUSES `RepWorklist` RATHER THAN RENDERING A SECOND VIEW.
               That model is ranked, tiered and verified against all nine real
               books; a manager looking at a rep must see the SAME screen the rep
               sees, or the two of them are reading different books. Scoping is a
               filter, which `setFilters` already owns — so this is one line and
               no new surface. */
            onRep={rep => setParams(previous => { const next = writeBoardFilters(previous, filters => ({ ...filters, owner: rep }), EMPTY_FILTERS); next.set('view', 'worklist'); return next })}
            /* ⭐ AND THE UNASSIGNED COUNT OPENS THE RECORDS. The Assignments
               view already holds the engine's proposals, the rep picker and the
               mandatory-reason field wired to `api.assignRep`, which the server
               refuses without a reason. So the fix is to make the number a door
               to the surface that already does the work — not a fourth
               enabled-but-dead control. */
            /* ⚠️ NO FILTER IS SET ON THE WAY, AND THAT IS NOT LAZINESS — THE
               OWNER FILTER CANNOT EXPRESS "UNASSIGNED". The board filters with
               `if (filters.owner && ownerName(c) !== filters.owner)`, and
               `ownerName()` returns `''` for nobody, so the only value that
               would select unassigned records is `''` — which the same line
               reads as "no filter at all". The Assignments view derives its own
               needs-a-rep list from the records, so it does not need one; a
               manager wanting the BOARD scoped to unassigned still cannot have
               it, which is a real gap in the filter and is reported rather than
               worked around with a sentinel the filter would mis-read. */
            onUnassigned={manageAssignments.allowed ? () => setView('assignments') : undefined}
          />}
          {activeView === 'map' && (
            <div className={`card ${styles.mapCard}`}>
              <CrownMap
                byState={byState}
                mode="state"
                footprint={null}
                selected={filters.state || null}
                onSelect={(code) => setFilters((s) => ({ ...s, state: s.state === code ? '' : code }))}
                /* The space's OWN word for a record — never "championship"
                   outside the Championships space. */
                noun={spaceNoun.singular}
                nounPlural={spaceNoun.plural}
              />
              {/* ⭐ THE MAP BECOMES A WORK SURFACE. Brian: "when a state is
                  selected I should be able to see what championships there are,
                  not just a map that shows pretty colors."
                  Selecting a region used to set `filters.state` and nothing
                  else, so on the map view the records behind a fill were
                  unreachable without leaving the map. `lensed` rather than
                  `visible` on purpose: `visible` is already narrowed BY the
                  state filter, so passing it would make the panel a list of
                  what the panel itself selected. */}
              <StatePanel
                code={filters.state || null}
                items={lensed}
                onOpen={openDrawer}
                onClear={() => setFilters((s) => ({ ...s, state: '' }))}
                noun={spaceNoun.singular}
                nounPlural={spaceNoun.plural}
              />
            </div>
          )}
          </ErrorBoundary>
          {/* WHO LANDED IT - Brian 2026-10-26: every completed task and every
              automated landing shows whether Jarvis (Claude) or Dot (ChatGPT)
              did it. Both reads are server-stamped; lazy behind the
              disclosure, so a closed panel costs no request. */}
          {!demo && (
            <div id="cc-landings"><Disclosure id="cc-landings-details" label="Activity · last hunt and who landed it (Jarvis · Claude / Dot · ChatGPT)" className={styles.researchDetails}>
              <p><b>Last hunt</b></p>
              <LastHuntDetail state={lastHunt} reach={lastHuntReach} />
              <p><b>Recent landings</b></p>
              <RecentLandings limit={20} empty="Nothing has landed since the stamp went live." />
              <p><b>Engines and deploys</b></p>
              <EngineAgents />
            </Disclosure></div>
          )}
          <div id="cc-research"><Disclosure label="Research tools · recent winners, sweep, add records" className={styles.researchDetails}>
          {/* THE RECENT WINDOW, ABOVE THE UNIVERSE.
             *
             * "It's Monday, there was a big weekend. Did the 7am search
             * trigger, and how do the weekend's championships look?" That is
             * the question this page gets opened to answer, and until now it
             * could only be answered after ~128 sequential calls had finished
             * pulling 12,740 records so the browser could filter down to a
             * dozen.
             *
             * One request, rendered immediately, while the full load continues
             * underneath for the map and the rep books that genuinely need it.
             * Championships only — the pursuit spaces have no such window. */}
          {/* ⚠️ THE JUST-CONCLUDED ROWS OPEN THE RECORD. They were a dead list
              — the first panel on the page, showing exactly what a rep wants
              to act on, and nothing happened when you tapped it. Returns false
              when the universe is still paging so the row can say so instead
              of swallowing the tap. */}
          {category.source === 'championships' && !demo && (
            <Disclosure label="Recently concluded championships" className={styles.researchDetails}>
            <WeekBoard
              /* A championship SUB-space (Bowl Season, Postseason Runs) is a
                 filtered subset of the same object, so the global week panel
                 must be scoped to it. Null for the full Championships space,
                 which is therefore unchanged. */
              scopeIds={weekScopeIds}
              scopeLabel={category.label}
              scopeReady={status === 'done'}
              onOpen={(id) => {
                const rec = data.find((x) => String(x.id) === String(id))
                if (!rec) return false
                openDrawer(rec)
                return true
              }}
            />
            </Disclosure>
          )}

          {/* 🧭 BOWL DESKS, IN THE BOWL SEASON SPACE (2026-10-26). Brian asked for
              the split-conference selector "in bowl opportunity" and for the AAC to
              show as assigned; the Bowl Eligibility board is where per-school picks
              are made, and this is the same read surfaced where bowl games are
              worked, with the conference-level pick for a viewer who may assign. */}
          {category.key === 'bowls' && !demo && (
            <Disclosure label="Bowl desks by conference · who is going after each school" className={styles.researchDetails}>
              <BowlDeskPanel canPick={manageAssignments.allowed === true} inCommandCenter />
            </Disclosure>
          )}

          {/* Championship copy is verbatim pre-rail — see the note above. */}
          {!loading && !demo && status === 'done' && (
            <div className={styles.loadSummary}>
              {category.source === 'championships' ? (
                <>
                  {/* THE RECEIPT SAYS WHAT ACTUALLY HAPPENED.
                      It used to read "over 1 pages — cursor exhausted" on the
                      snapshot path, which issues ONE request and walks no
                      cursor. This is the sentence whose entire job is to prove
                      the full-universe load, so it must describe the path
                      actually taken rather than assume the paged one. */}
                  <strong>{data.length.toLocaleString()}</strong> {recordsLabelFor(category)} loaded live from HubSpot
                  {loadMode === 'snapshot' && (complete
                    ? ' in one prebuilt snapshot request — the complete object, no cursor to walk.'
                    : ' in one prebuilt snapshot request — partial.')}
                  {loadMode === 'paged' && (
                    complete
                      ? ` over ${pageCount.toLocaleString()} ${pageCount === 1 ? 'page' : 'pages'} — cursor exhausted, this is the complete object.`
                      : ` over ${pageCount.toLocaleString()} ${pageCount === 1 ? 'page' : 'pages'} — partial load.`
                  )}
                  {!loadMode && (complete ? ' — the complete object.' : ' — partial load.')}
                  <span className={styles.loadSummaryRo}>Read-only · the Command Center never writes back on load.</span>
                </>
              ) : (
                <>
                  <strong>{data.length.toLocaleString()}</strong> {recordsLabelFor(category)} loaded live from the
                  {' '}{category.line} pursuit line.
                  <span className={styles.loadSummaryRo}>Read-only space · no writes are offered here.</span>
                </>
              )}
            </div>
          )}

          {/* THE SWEEP — "what still has nobody recorded as winning?"
              Championships only: it reads HubSpot 2-64425303, which no pursuit
              row has a record in, so it is absent rather than dead elsewhere.
              Collapsed by default — a tool you reach for, not a thing you read. */}
          {writes && <SweepPanel />}
          {/* ADD — the sweep says what is missing a champion; this says what is
              missing from the board entirely. Championships only: it creates
              records on 2-64425303. */}
          {writes && <AddChampionship onAdded={reload} />}

          </Disclosure></div>

          <Disclosure label="Status and date key" className={styles.legendDetails}>
          {legend.length > 0 && (
          <div className={styles.legend}>
            <span className={styles.legendLabel}>Status</span>
            {legend.map((l) => (
              <span key={l.key} className={styles.legendItem}>
                <span className={styles.legendDot} style={{ background: l.color }} />
                {l.label}
              </span>
            ))}
            {/* The sport accent means nothing in a space whose records have no
                sport (Corporate), so the note is dropped rather than pointing
                at a bar that encodes nothing. */}
            {data.some((c) => c.sport) && (
              <>
                <span className={styles.legendSep} />
                <span className={styles.legendItem}><span className={styles.legendBar} /> left bar = sport</span>
              </>
            )}
            {/* ⚠️ A STAMP NOBODY CAN DECODE IS DECORATION. The legend states the
                count as well as the meaning, because "142 of 1,006" is what tells
                a rep how much of what they are looking at is a real date — and
                it is rendered off the SAME model function that draws the stamp,
                so the two can never disagree. Hidden when a space has none. */}
            {(() => {
              const n = data.filter((c) => dateStamp(c)?.kind === 'sourced').length
              if (!n) return null
              return (
                <>
                  <span className={styles.legendSep} />
                  <span className={styles.legendItem}>
                    <DateStamp c={{ dateStatus: 'Confirmed', effDate: new Date() }} compact />
                    {/* "this body's own calendar" is governing-body wording. An
                        RFP's close date is set by the ISSUER on a solicitation,
                        not crowned on a calendar, so the space says which. */}
                    {' '}= official {dateLabel.toLowerCase()},{' '}
                    {category.source === 'championships'
                      ? 'read off this body’s own calendar'
                      : 'read off the issuer’s own posting'}
                    {' '}<strong>({n.toLocaleString()} of {data.length.toLocaleString()})</strong>
                  </span>
                </>
              )
            })()}
          </div>
          )}
          </Disclosure>


        </>
      )}

      {drawer && (
        <ChampionshipDrawer
          key={drawer.id}
          champ={drawer}
          initialTask={params.get('work')}
          campaignWorkspace={writes&&!drawer.isIndyGroup&&!drawer.sourceType&&!splitParentSummary(drawer)?<RecordCampaignWorkspace record={drawer} onMove={demo?null:board.moveCard} onNavigate={(section,proof,jobId)=>navigateIfChanged(campaignParams(params,{championshipId:drawer.id,section,proof,jobId}))}/>:null}
          onWorkspaceSection={section=>{const next=new URLSearchParams(params);next.set('work',section);navigateIfChanged(next)}}
          now={now}
          onClose={closeDrawer}
          /* The console is championship-only — see `allowsWrites`. */
          showActions={writes && !drawer.isIndyGroup}
          spaceLabel={category.label}
          /* THE SPACE ITSELF — the pursuit field editor is an opt-in per LINE
             (`allowsFieldEdits` in categories.js), and the line selects the
             field policy. Deliberately NOT folded into `writes`/`allowsWrites`,
             which governs the CHAMPIONSHIP writes (crown, Submit-for-Win, the
             dossier) against HubSpot 2-64425303 — an object no pursuit row has
             a record in. Two different write systems, two different gates. */
          category={category}
          /* …except for the one action an organization space DOES offer: the
             hero nomination / pursuit create. It replaces nothing. */
          rowAction={rowAction}
          /* ═══ THE CROSS-TAB THREAD ═══
             Brian: "integration between every single tab is Paramount."

             `championships` is the FULL championship plane, which this
             hook keeps mounted in EVERY space — so a Bowl Season drawer can
             reach a Postseason Runs record, and vice versa, with no extra
             request and no second fetch to drift against.

             Deliberately the full plane, NOT `rows`: `rows` is what the current
             tab shows, and relating a record only to its own tab is precisely
             the isolation this fixes. */
          universe={championships || []}
          onOpenRelated={c=>openDrawer(c,null,true)}
          onCreateArt={writes ? onCreateArt : undefined}
          onCampaign={writes ? onCampaign : undefined}
          onQuote={writes ? onQuote : undefined}
          onSubmitWin={writes ? onSubmitWin : undefined}
          /* Same gate as the crown: both target HubSpot 2-64425303, which no
             pursuit-space row has a record in. */
          onCorrect={writes ? onCorrect : undefined}
          onOpenDossier={writes ? c=>openDossier(c,'outreach') : undefined}
          /* THE ASSIGNMENT PANEL — the suggestion, the picker and the from → to
             history. Championship-space only, for the same reason the console
             is: the write targets 2-64425303. */
          /* `error` is passed IN because the drawer covers the page-level
             notice. Without it, an assignment that fails while the drawer is
             open reports nowhere at all — a silent failure, which is strictly
             worse than the bare "failed" this change is removing. */
          assign={writes && !drawer.isIndyGroup ? { gate: manageAssignments, onAssign: assign, busyId: assignState.busyId,
            error: assignState.error, errorKind: assignState.errorKind } : null}
          /* WITHDRAW AN UNSOURCED CROWN. Same gate as the crown write — it
             targets 2-64425303. `degraded` is passed because a read that fell
             back to the core property set returns neither the source URL nor
             the lock, so every crowned record would look sourceless and
             unlocked; the control refuses to judge a record on that page, which
             is the same refusal the server makes. */
          onCrownCleared={writes ? onCrownCleared : undefined}
          readDegraded={Boolean(degraded)}
          /* CORRECT A FIELD ON THE RECORD. Same gate as every other write here
             — `champion-update` targets 2-64425303, which no pursuit-space row
             has a record in. `writes` is `allowsWrites(category)`, true for the
             Championships space alone, so the correction controls are absent
             everywhere else rather than offered dead. The drawer ALSO checks
             `showActions` and the record's own `sourceType`, because the page
             flag and the record marker fail in different directions. */
          onFieldEdited={writes ? onFieldEdited : undefined}
        />
      )}
      {artworkComposer?.locationKey===location.key && <SavedArtworkComposer proof={artworkComposer.proof} onClose={()=>setArtworkComposer(null)} onSaved={()=>setArtworkStatusRevision(value=>value+1)} onAdvanced={()=>{const selected=artworkComposer;setArtworkComposer(null);openDossier(selected.row.record,'outreach');setDossierArtworkProof(selected.proof)}}/>}
      {dossierTarget && <ChampionToClose champ={dossierTarget} initialSection={dossierSection} initialArtworkProof={dossierArtworkProof} returnTo={`/command-center?${params}`} onClose={() => setDossierTarget(null)} />}
      {/* The recognition / pursuit create flow — LIVE. It composes the deal and
          POSTs it to /api/recognition-deal, which re-decides governance and
          answers created / already-recorded / conflict. `onCreated` patches the
          record so the badge reflects the new deal without a refetch. */}
      {recognize && (
        <RecognitionModal
          kind={recognize.kind}
          record={recognize.record}
          onClose={() => setRecognize(null)}
          onCreated={onRecognitionCreated}
        />
      )}
      {crown && (
        <CrownModal
          record={crown}
          mode="crown"
          busy={crownBusy}
          error={crownError}
          onClose={() => { setCrown(null); setCrownError('') }}
          onSubmit={submitCrown}
        />
      )}
      {correct && (
        <CrownModal
          record={correct}
          mode="edit"
          busy={crownBusy}
          error={crownError}
          onClose={() => { setCorrect(null); setCrownError('') }}
          onSubmit={submitCorrection}
        />
      )}
    </div>
  )
}

export default function CommandCenter(){
  const [params]=useSearchParams(),access=useToolAccess()
  const category=categoryFor(params.get('space')||DEFAULT_CATEGORY_KEY)
  const supported=key=>!['partnership','workorder'].includes(key)
  // A retained policy preserves mounted form state only while ToolGate holds interaction.
  const policy=access?.checking?access?.retainedData:access?.data
  const allowed=viewsFor(category).filter(v=>!supported(v.key)||toolAvailable(policy,'cc.'+v.key))
  const requested=params.get('view')||(params.get('day')?'calendar':null)
  const preferred=preferredRepView(category,allowed)
  const selected=requested||(allowed.some(v=>v.key===preferred)?preferred:allowed[0]?.key)
  if(!selected)return <section role="status"><h2>No Command Center views available</h2><p>{access?.error||'Your available views are being checked or have been paused.'}</p><button className="btn" onClick={()=>access?.refresh()}>Refresh access</button></section>
  if(!category.views.includes(selected))return <section role="status"><h2>View unavailable in this space</h2></section>
  const content=<CommandCenterContent effectiveView={selected}/>
  return supported(selected)?<ToolGate id={'cc.'+selected}>{content}</ToolGate>:content
}
